import { locale } from '@/helpers/locale'
import store from '@/store'

export function formatAmount(amount: number | string, isRounded = true): string {
  const currency = store.state.userProfile.currency || 'GBP'
  const currencyConversionRate = store.state.userCurrencyConversionRate || 1
  const number = parseFloat(String(amount));
  const convertedNumber = number * currencyConversionRate;
  const fraction = convertedNumber - Math.floor(convertedNumber);

  // If the fraction is less than 0.01 (e.g. 0.001), treat it as though it's a whole number
  const fractionDigits = fraction < 0.01 ? 0 : 2;

  return convertedNumber.toLocaleString(locale, {
    style: 'currency',
    minimumFractionDigits: !isRounded ? 2 : fractionDigits,
    currency,
  })
}
